import axios from "axios";
import { baseURL } from "../config/api";

export const post_Customer = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}self?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Customer = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}self?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getExistingustomer = (email: string, birthday: string, tenantId: string) => {
    return getFetch(`self/GetExistingCustomer?emailAddress=${email}&Birthday=${birthday}`, tenantId)
}

export const getCustomer = (primaryKey: number, tenantId: string) => {
    return getFetch(`self/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}